export default {
  namespaced: true,
  state: {
    filterType: '',
    filterKeyword: '',
    orderBy: '',
    orderDirection: ''
  },
  mutations: {
    setFilterType(state, filterType) {
      state.filterType = filterType;
    },
    setFilterKeyword(state, filterKeyword) {
      state.filterKeyword = filterKeyword;
    },
    setOrderBy(state, orderBy) {
      state.orderBy = orderBy;
    },
    setOrderDirection(state, orderDirection) {
      state.orderDirection = orderDirection;
    },
  }
}